import { Box, styled } from '@mui/material';
import type { Node } from '@xyflow/react';
import { FormProvider, useForm } from 'react-hook-form';
import { WorkflowSidebarFooter } from 'ogp/components/views/management/workflows/common/workflow-editor/workflow-sidebar/edit-node-form/nodes/common/workflow-sidebar-footer/workflow-sidebar-footer';
import { ActionNodeFormValues } from './action-node-editor.types';

export const ActionNodeEditor = ({
  node,
  onSave,
  onClose,
}: {
  node: Node;
  onSave: (data: Record<string, unknown>) => void;
  onClose: () => void;
}) => {
  const source = (node.data ?? {}) as Partial<ActionNodeFormValues>;
  const form = useForm<ActionNodeFormValues>({
    defaultValues: {
      value: source.value ?? [],
    },
  });

  const submit = form.handleSubmit((values) => {
    onSave({
      ...(node.data ?? {}),
      value: values.value,
    });
    onClose();
  });

  return (
    <FormProvider {...form}>
      <EditorWrapper>
        <ContentWrapper>
          <Title>Action</Title>
          <Description>No action types are currently available.</Description>
        </ContentWrapper>
        <WorkflowSidebarFooter onClose={onClose} submit={submit} />
      </EditorWrapper>
    </FormProvider>
  );
};

const EditorWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const ContentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  flex: 1,
  overflowY: 'auto',
  padding: '12px 4px',
});

const Title = styled(Box)({
  fontWeight: 700,
  fontSize: 18,
  textAlign: 'center',
  marginBottom: 12,
  marginTop: 12,
});

const Description = styled(Box)({
  fontSize: 14,
  textAlign: 'center',
});
